import React from 'react';
import PropTypes from "prop-types";

import {connect} from "react-redux";
import { patchSocialLink } from 'redux/social/actions';
import { setLastPatchedId } from 'redux/common/actions';

import CommonInputField from 'components/elements/inputs/CommonInputField';

import validate from 'components/dashboard/social-content/utils-validation/validate';
import { modifyInputValue } from
  'components/dashboard/social-content/utils-validation/utils';

import './SocialLinkItemValue.css';


function SocialLinkItemValue(props) {
  const {
    patchSocialLink,
    item,
    patchSocialLinkError,
    socialNetworksList,
    setLastPatchedId,
    lastPatchedId,
  } = props;

  const validation = value => {
    if (!value) return 'Value should not be empty';

    return validate(
      socialNetworksList,
      item.social_network.type,
      item.social_network.name.toLowerCase(),
      value,
    );
  };

  return (
    <div className="social-link-item-value__component">
      <CommonInputField
        key={`social-link-value-input-key-${item.id}`}
        editIcon
        initialValue={item.value}
        executedFunction={value => {
          const form = new FormData();
          form.append(
            'value',
            modifyInputValue(
              value,
              item.social_network.type,
              item.social_network.name.toLowerCase(),
            )
          );
          patchSocialLink(item.id, form);
          setLastPatchedId(item.id);
        }}
        serverErrors={
          lastPatchedId === item.id &&
          patchSocialLinkError &&
          patchSocialLinkError.value
        }
        validationFunction={validation}
      />
    </div>
  );
}

SocialLinkItemValue.propTypes = {
  patchSocialLink: PropTypes.func.isRequired,
  setLastPatchedId: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  patchSocialLinkError: PropTypes.object,
  socialNetworksList: PropTypes.arrayOf(PropTypes.shape),
  lastPatchedId: PropTypes.number,
};

SocialLinkItemValue.defaultProps = {
  patchSocialLinkError: null,
  socialNetworksList: null,
  lastPatchedId: null,
};

const mapStateToProps = state => (
  {
    patchSocialLinkError: state.socialReducer.patchSocialLinkError,
    socialNetworksList: state.socialReducer.socialNetworksList,
    lastPatchedId: state.commonReducer.lastPatchedId,
  }
);

export default connect(
  mapStateToProps,
  {
    patchSocialLink,
    setLastPatchedId,
  },
)(SocialLinkItemValue);
